<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-10-14 16:50:34
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-28 14:10:10
 -->
<template>
  <div class="main">
    <div class="gray_bg">
      <el-row>
        <el-col :span="24" class="nav_div" :class="fixedNav">
          <div>
            <div>
              <img src="/base/images/cloudOffice/logo.png" class="logo_img" alt="">
              <span class="logo_title">
                云上办公室
              </span>
            </div>

            <div>
              <el-button type="primary" class="login_now" @click="loginNow">立即登录</el-button>
              <span class="tel">400-639-0198</span>
              <img src="/base/images/cloudOffice/icon_phone.png" class="tel_img" alt="">
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-top:80px">
        <el-carousel height="470px" arrow="never">
          <el-carousel-item>
            <el-col :span="24" class="banner">
              <el-col :span="12" class="banner_bgtop">
                <p class="font-large pht jbyj delay1 fadeInLeftBig">
                  <<让办公和学校管理更轻松 </p>
                    <p class="font-large pht zlys delay2 fadeInLeftBig ">
                      云上办公室
                    </p>

                    <p class="font-small delay3 fadeInLeftBig ">
                      围绕企业的“降本增效”服务，展开协作与管理，构建高效率协作团队
                    </p>

                    <el-button type="primary" class="ty_now myBtn delay4 fadeInLeftBig"
                      @click="tryNow(index)">马上体验</el-button>
              </el-col>
              <img src="/base/images/cloudOffice/banner.png" alt="">
            </el-col>
          </el-carousel-item>
          <el-carousel-item>
            <el-col :span="24" class="banner">
              <el-col :span="12" class="banner_bgtop">
                <p class="">
                  <span style="font-size:28px;">通</span>过门户系统、工作流引擎、文档管理、系统管理等支撑系统，
                </p>
                <!-- <p class="font-large pht zlys delay2 fadeInLeftBig ">
                    云上办公室2
                </p> -->

                <p class="font-small delay3 fadeInLeftBig ">
                  提供灵活、稳定、安全、高效的一体化智慧办公。
                </p>

                <el-button type="primary" class="ty_now myBtn2 animate__animated animate__heartBeat mt30"
                  @click="tryNow(index)">助力高校一体化办公</el-button>
              </el-col>
              <img src="/base/images/cloudOffice/banner1.png" alt="">
            </el-col>
          </el-carousel-item>
        </el-carousel>

      </el-row>
    </div>

    <div class="white_bg">
      <div class="cloudOffice">
        <el-row class="areaDiv">
          <el-col :span="6" v-for="(item, index) in areaList" :key="index">
            <div class="areaTab">
              <img :src="item.imgSrc" alt="">
              <h5>{{item.title}}</h5>
              <p>{{item.detail1}}</p>
              <p>{{item.detail2}}</p>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-row>
        <el-col :span="24" class="center banner_bg">
          <div class="chinese_font">
            <span class="blue_font">流程管理</span>更简单、信息共享更高效
          </div>
          <div class="english_font">
            数字化解决方案，解决组织管理难题，为企业管理赋能
          </div>
        </el-col>
      </el-row>
      <div class="cloudOffice">
        <el-row id="0" class="condition-container">
          <el-col :span="16">
            <img src="/base/images/cloudOffice/pic_1.png" width="747px" alt="">
          </el-col>
          <el-col :span="8">
            <div class="tab_title border_orange">
              流程配置
            </div>
            <div class="tab_info">
              30+流程功能轻松实现无代码个性配置
            </div>
            <div class="tab_info">
              审批、流程、财务、行政、人事、客户全在线，执行流程全部留痕可追踪
            </div>
            <div>
              <el-button type="primary" class="myBtn_blue" @click="tryNow(index)">马上体验</el-button>
            </div>
          </el-col>
        </el-row>

        <el-row class="condition-container" id="1">

          <el-col :span="8">
            <div class="tab_title border_blue">
              提升企业效率
            </div>
            <div class="tab_info">
              从任务分发到工时绩效流程化
            </div>
            <div class="tab_info">
              建立从目标计划、到执行反馈、定期检查、以及完成总结分享的闭环工作机制
            </div>
            <div>
              <el-button type="primary" class="myBtn_blue" @click="tryNow(index)">马上体验</el-button>
            </div>
          </el-col>
          <el-col :span="16" class="right">
            <img src="/base/images/cloudOffice/pic_2.png" width="747px" alt="">
          </el-col>
        </el-row>
        <el-row id="2" class="condition-container">
          <el-col :span="16">
            <img src="/base/images/cloudOffice/pic_3.png" width="747px" alt="">
          </el-col>
          <el-col :span="8">
            <div class="tab_title border_orange">
              形成数据资产
            </div>
            <div class="tab_info">
              沉淀数据、数据和逻辑，加速数据到数据资产的形成，解决数据不一致的问题，不断发挥数据价值，进而支持业务的决策和优化
            </div>
            <div class="tab_content">
              <span>效率提升</span>
              <span style=" margin-right: 20px; margin-left: -20px;">
                <img src="/base/images/cloudOffice/blue_icon_right.png" alt="">
              </span>
              <span>奖励/分享</span>
            </div>

            <div class="tab_content">
              <span>效率降低</span>
              <span style=" margin-right: 20px; margin-left: -20px;">
                <img src="/base/images/cloudOffice/blue_icon_right.png" alt="">
              </span>
              <span>复盘/总结</span>
            </div>
            <div>
              <el-button type="primary" class="myBtn_blue" @click="tryNow(index)">马上体验</el-button>
            </div>
          </el-col>
        </el-row>

      </div>
      <el-row style="background-color:#eff7ff;text-align:center;display: flex;flex-direction: column;">
        <el-col :span="12" :offset="6">
          <el-row class="yyfa_top">
            <el-col :span="6">
              <div class="mydivider"></div>
            </el-col>
            <el-col :span="12">
              <div>
                <h2 style="color:#5178f3;">不同角色应用方案</h2>
                <p style="color:#999999;">审批、流程、财务、行政、人事、客户全在线</p>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="mydivider"></div>
            </el-col>
          </el-row>
        </el-col>
        <!-- <el-row class="yyfa_content"> -->
        <el-col :span="24" class="yyfa_content">
          <el-carousel indicator-position="outside" arrow="never">
            <el-carousel-item v-for="item in area2List" :key="item" :label="item.title">
              <el-row class="tg">
                <el-col :span="12" class="tg lunboLeft">
                  <h5>{{item.title}}</h5>
                  <p>{{item.detail}}</p>
                  <el-button type="primary" class="ty_now myBtn_blue delay4 fadeInLeftBig"
                    @click="tryNow(index)">马上体验</el-button>
                </el-col>
                <el-col :span="10" offset="2" class="tg lunboRight">
                  <img :src="item.imgSrc" alt="">
                </el-col>
              </el-row>
            </el-carousel-item>
          </el-carousel>
        </el-col>

        <!-- </el-row> -->
      </el-row>
      <!-- <el-row>
                <el-col :span="24" class="center yyfa_bg">
                    <el-row>
                        <el-col :span="12" :offset="6">
                            <el-row class="yyfa_top">
                                <el-col :span="6">
                                    <div class="mydivider"></div>
                                </el-col>
                                <el-col :span="12" style="color:#ffffff;">
                                    <div>
                                        <h2>不同角色应用方案</h2>
                                        <p>审批、流程、财务、行政、人事、客户全在线</p>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="mydivider"></div>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-row class="yyfa_content">
                        <el-col :span="6" v-for="(item, index) in area2List" :key="index">
                            <div class="areaTab">
                                <img :src="item.imgSrc" alt="">
                                <h5>{{item.title}}</h5>
                                <p>{{item.detail}}</p>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row> -->
      <div class="white_bg">
        <div class="cloudOffice">
          <el-row class="center">
            <h2>以客户为中心的陪伴式服务</h2>
            <p>围绕客户购买后的全生命周期运营，提供1V1的陪伴服务</p>
          </el-row>
          <el-row class="pbsfw_content">
            <div class="areaTab myborder" v-for="(item, index) in area3List" :key="index">
              <img :src="item.imgSrc" alt="">
              <h5>{{item.title}}</h5>
              <p>{{item.detail}}</p>
            </div>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 右侧悬浮 -->
    <div class="kjgn">
      <div v-for="(item, index) in area4List" :key="index">
        <div class="areaTab" v-if="item.title=='免费试用'" @click="tryNow(index)">
          <img :src="item.imgSrc" alt="">
          <h5>{{item.title}}</h5>
          <div v-if="index=='1'" class="kfdh">400-639-0198</div>
        </div>
        <div class="areaTab" v-else>
          <img :src="item.imgSrc" alt="">
          <h5>{{item.title}}</h5>
          <div v-if="index=='1'" class="kfdh">400-639-0198</div>
        </div>
      </div>
    </div>

    <el-row class="footer">
      <!-- <el-col :span="24" class="center">
        <div class="footer_title">
          友情链接
        </div>
    </el-col> -->
      <el-col :span="24" class="footer_top">
        <div class="footer_link">友情链接：</div>
        <div class="footer_link">
          <a href="http://www.vipschools.net/" target="_blank">
            <img src="/base/images/cloudOffice/logo_yunshang.png" alt="">
            云上学校（www.vipschools.net）
          </a>
        </div>
        <div class="footer_link">
          <a href="http://www.growthschool.cn/" target="_blank">
            <img src="/base/images/cloudOffice/logo_chengzhang.png" alt="">
            成长学校（ www.growthschool.cn）
          </a>
        </div>
        <div class="footer_link">
          <a href="http://www.wiseloong.com/" target="_blank">
            <img src="/base/images/cloudOffice/logo_longyun.png" alt="">
            关于我们（www.wiseloong.com）
          </a>
        </div>
        <!-- <div class="footer_link">&nbsp;</div> -->
      </el-col>

      <el-col :span="24" class="footer_info">
        <el-col :span="12" class="el-col-12-first">
          版权所有：上海智隆信息技术股份有限公司
        </el-col>
        <el-col :span="12" class="el-col-12-last">
          沪公网安备 31011502002582号 <a href="https://beian.miit.gov.cn" style="color: #ffffff">沪ICP备19000885号-2</a>
        </el-col>
      </el-col>
    </el-row>
    <el-dialog title="" :visible.sync="show" width="30%" :before-close="handleClose">
      <!-- 弹窗 -->
      <el-row class="margin-tp-100" id="formRow">
        <el-col :span="24" class="center">
          <div class="form_title">
            助力中小企业高效运作管理公司流程
          </div>
          <div class="form_info">
            集合、安全、稳定、易用
          </div>
        </el-col>
        <el-col :span="24">
          <div class="form_div">
            <div class="form_group">
              <el-input placeholder="公司名称" v-model="form.companyName">
              </el-input>
            </div>
            <div class="form_group">
              <el-select v-model="form.staffSize" placeholder="人员规模">
                <el-option v-for="item in form.staffSizeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>

            <div class="form_group">
              <el-input placeholder="您的称呼" v-model="form.name">
              </el-input>
            </div>

            <div class="form_group">
              <el-input placeholder="手机号码" v-model="form.phoneNum">
              </el-input>
            </div>

            <div class="center">
              <el-button type="primary" class="now_yy" @click="reserve">预约体验</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog title="" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div class="center">
        <img src="/base/images/cloudOffice/success.png" width="61px" alt="">
      </div>
      <div class="center" style="font-size: 36px; color: black; margin-top: 16px;">
        预约成功
      </div>
      <div style="font-size: 18px;margin-top: 30px;text-align: center;color: #222;">
        感谢预约体验，请留意电话的提示
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">好的</el-button>
      </span>
    </el-dialog>
  </div>

</template>
<script>
import '@/framework/assets/style/font.scss'
export default {
  data() {
    return {
      show: false,
      dialogVisible: false,
      current: 0,
      tabList: [
        { imgSrc: '/base/images/cloudOffice/icon_lcpz.png', tabText: '流程配置' },
        { imgSrc: '/base/images/cloudOffice/icon_lcjk.png', tabText: '流程监控' },
        { imgSrc: '/base/images/cloudOffice/icon_sjfx.png', tabText: '数据分析' },
        { imgSrc: '/base/images/cloudOffice/icon_xxgx.png', tabText: '信息共享' }
      ],
      area4List: [
        { imgSrc: '/base/images/cloudOffice/icon_free.png', title: '免费试用' },
        { imgSrc: '/base/images/cloudOffice/icon_iphone.png', title: '电话沟通' },
        { imgSrc: '/base/images/cloudOffice/icon_weixin.png', title: '微信咨询' }
      ],
      areaList: [
        {
          imgSrc: '/base/images/cloudOffice/icon_xxgxNew.png',
          title: '信息共享',
          detail1: '审批、流程、财务、行政、人事、',
          detail2: '客户全在线'
        },
        {
          imgSrc: '/base/images/cloudOffice/icon_gzlh.png',
          title: '工作留痕',
          detail1: '积累每天每人每事的过程，并自动汇报、',
          detail2: '沉淀和形成内部长期可用的经验分享'
        },
        {
          imgSrc: '/base/images/cloudOffice/icon_jxkh.png',
          title: '绩效考核',
          detail1: '任务、主管、HR三维评价 ',
          detail2: '绩效考核更客观全面 '
        },
        {
          imgSrc: '/base/images/cloudOffice/icon_khgl.png',
          title: '客户管理',
          detail1: '从营销、销售到服务的',
          detail2: '全流程自动化业务场景'
        }
      ],
      area2List: [
        {
          imgSrc: '/base/images/cloudOffice/khzx.png',
          title: '客户在线',
          detail: '客户信息详尽记录，支持自定多个联系人与财务信息，同步销售、合同、财务等多端业务人员对同一个客户的“认识”，避免信息不对称或版本不一致问题。'
        },
        {
          imgSrc: '/base/images/cloudOffice/lcsp.png',
          title: '流程审批',
          detail: '随时可追踪流程当前进度，可以全面覆盖企业日常各类请假、出差、IT申请、招聘需求申请、行政服务申请等。更可支持项目、研发业务流程审批与管理。'
        },
        {
          imgSrc: '/base/images/cloudOffice/fybx.png',
          title: '费用报销',
          detail: '随时随地申请、借款、报销，费用自动流转推送，有效提升工作效率和员工满意度。 '
        },
        {
          imgSrc: '/base/images/cloudOffice/yxjh.png',
          title: '营销计划',
          detail: '集中管理来自不同状态客户信息，轻松展示销售趋势、营销成果，更好地与客户开展互动，帮助团队加强对客户的了解，与团队共享。'
        },
        {
          imgSrc: '/base/images/cloudOffice/rwff.png',
          title: '任务分发',
          detail: '建立从目标计划、到执行反馈、定期检查、以及完成日报周报总结分享的闭环工作机制。'
        },
        {
          imgSrc: '/base/images/cloudOffice/xmgz.png',
          title: '项目跟踪',
          detail: '通过跟踪、监测，及时了解项目计划的实际执行情况，评价项目状态，为项目组长以及各级管理者提供项目当前真实情况的可视性。'
        },
        {
          imgSrc: '/base/images/cloudOffice/khpj.png',
          title: '绩效考核',
          detail: '倡导敏捷绩效理念，帮助企业实现战略目标的逐层分解，并通过对任务目标的即时评价与持续反馈、可配置多种绩效角色，多维考核关系，分值权重，满足不同企业的绩效需求；有效实现对员工的及时激励与客观评价，驱动员工成长，成就高绩效组织。'
        },
        {
          imgSrc: '/base/images/cloudOffice/kshbb.png',
          title: '可视化报表',
          detail: '精细化BI分析，对目标执行情况进行可视化，帮助管理者及时识别风险，促进目标达成，大幅提升企业管理决策效率与决策能力；'
        }

      ],
      area3List: [
        {
          imgSrc: '/base/images/cloudOffice/icon_1v1.png',
          title: '专属服务管家1V1',
          detail: '每位客户配备专属服务管家'
        },
        {
          imgSrc: '/base/images/cloudOffice/icon_5min.png',
          title: '留言5分钟内响应',
          detail: '7*16小时不间断在线留言，5分钟内极速响应'
        },
        {
          imgSrc: '/base/images/cloudOffice/icon_24h.png',
          title: '需求24小时反馈',
          detail: '需求24小时内高效反馈第一时间服务客户需求 '
        },
        {
          imgSrc: '/base/images/cloudOffice/icon_365.png',
          title: '保障365日全天候护航',
          detail: '365日全天候服务护航保障客户业务顺利开展'
        }
      ],

      fixedNav: '',
      form: {
        companyName: '',
        name: '',
        phoneNum: '',
        staffSize: '',
        staffSizeList: [
          {
            label: '0-20人',
            value: '0-20人'
          },
          {
            label: '20-50人',
            value: '20-50人'
          },
          {
            label: '50-200人',
            value: '50-200人'
          },
          {
            label: '200-500人',
            value: '200-500人'
          },
          {
            label: '500人以上',
            value: '500人以上'
          }
        ]
      }
    }
  },
  created() {
    this.listenerFunction()
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.listenerFunction)
  },

  methods: {
    changeTabActive: function (index) {
      this.current = index
      let jump = document.querySelectorAll('.condition-container')
      jump[index].scrollIntoView({ block: 'center', behavior: 'smooth' })
    },
    listenerFunction(e) {
      document.addEventListener('scroll', this.handleScroll, true)
    },
    tryNow: function () {
      //   let jump = document.querySelectorAll('#formRow')
      //   jump[0].scrollIntoView({ block: 'center', behavior: 'smooth' })
      this.show = true
    },
    // handleScroll() {
    //   var dis = this.$refs.obtain.getBoundingClientRect().top

    //   if (dis < 70) {
    //     this.fixedNav = 'fixedNav'
    //   } else {
    //     this.fixedNav = ''
    //   }
    // },
    loginNow: function () {
      this.$router.push({ name: 'loginNow' })
    },
    // 预约体验
    reserve() {
      if (!this.form.companyName) {
        this.$message.info('请填写公司名称')
      } else if (!this.form.staffSize) {
        this.$message.info('请填写人员规模')
      } else if (!this.form.name) {
        this.$message.info('请填写您的称呼')
      } else if (!this.form.phoneNum || !/^1[0-9]{10}$/.test(this.form.phoneNum)) {
        this.$message.info('请填写正确的手机号码')
      } else {
        this.$http.post('/t-appointment-filling/saveAppointmentFilling', null, {
          params: {
            corporateName: this.form.companyName,
            mobile: this.form.phoneNum,
            name: this.form.name,
            staffSize: this.form.staffSize
          }
        }).then(res => {
          this.dialogVisible = true
          // this.$message.success('预约成功')
        }).catch(error => {
          this.$message.error(error.msg || error.message)
        })
      }
    }

  }

}
</script>
<style lang="scss" scoped>
.delay1 {
  animation: fadeInLeftBig 1.5s;
}
.delay2 {
  animation: fadeInLeftBig 2s;
}
.delay3 {
  animation: fadeInLeftBig 2.5s;
}
.delay4 {
  animation: fadeInLeftBig 3s;
}
.form_div {
  width: 100%;
  margin: auto;
}
:deep(.el-select) {
  width: 100%;
}
:deep(.el-input__inner) {
  height: 45px;
  border-radius: 12px;
  font-size: 16px;
}
.form_title {
  font-size: 25px;
  margin-bottom: 15px;
}
.form_info {
  font-size: 24px;
  margin-bottom: 20px;
}
.form_group {
  margin-bottom: 24px;
}
.kjgn {
  position: fixed;
  top: 30%;
  right: 6px;
  z-index: 999;
  width: 100px;
  height: 300px;
  display: flex;
  background-color: #fff;
  flex-direction: column;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .areaTab {
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    position: relative;
    cursor: pointer;
    img {
      height: 40px;
    }
    h5 {
      font-weight: normal;
      margin: 0;
    }
    .kfdh {
      right: 120px;
      width: 120px;
      border: 1px solid #e5e5e5;
      position: absolute;
      display: none;
      color: #5178f3;
      // background-color: #fff;
      text-align: center;
      line-height: 2;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      border-radius: 5px;
    }
  }
  & > div:nth-child(2) {
    background-color: #5178f3;
    color: #ffffff;
  }
  & > div:nth-child(2):hover .kfdh {
    display: block;
  }
}
.blue_font {
  color: #5178f3;
}
.yyfa_top {
  display: flex;
  align-items: center;
}
.yyfa_content {
  //   background-color: rgba(0, 0, 0, 0.5);
  margin: 0 auto;
  width: calc(100% - 240px);
  height: 400px;
  min-width: 1200px;
  //   .areaTab {
  //     display: flex;
  //     flex-direction: column;
  //     align-items: center;
  //     padding: 40px;
  //     color: #ffffff;
  //     height: 300px;
  //     box-sizing: border-box;
  .lunboLeft {
    padding-right: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
  }
  h5 {
    margin: 0;
    line-height: 3;
    font-size: 20px;
    color: #5178f3;
    text-align: left;
  }
  img {
    width: 100%;
    height: 100%;
  }
  p {
    color: #717273;
    font-size: 12px;
    //   text-indent: 2em;
    text-align: left;
  }
  .el-button {
    float: left;
  }
  .myBtn_blue {
    border-radius: 25px;
    background-color: #2e5cf1;
    color: #ffffff;
    font-weight: 600;
  }
  //   }
  :deep(.el-carousel) {
    .el-carousel__indicators {
      height: 50px;
    }
    .el-carousel__indicator.is-active > .el-carousel__button {
      background: #5178f3 !important;
    }
    .el-carousel__indicators--labels .el-carousel__indicator {
      width: 150px;
      height: 8px;
      padding: 0;
      background-color: #dfe3ef;
      position: relative;
    }
    .el-carousel__indicators--labels .el-carousel__button {
      padding: 0;
      border-radius: 50%;
      position: absolute;
      width: 25px;
      height: 25px;
      background: #dfe3ef;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border: 1px solid #eee;
      opacity: 1 !important;
    }
    button.el-carousel__button span {
      position: absolute;
      left: -14px;
      width: 150px;
      top: 28px;
      text-align: left;
      color: #666666;
    }
  }
}
.pbsfw_content {
  height: 250px;
  margin: 40px 0;
  min-width: 1200px;
  display: flex;
  .areaTab {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 50px;
    color: #333333;
    box-sizing: border-box;
    width: 25%;
    margin: 0 20px;
    position: relative;
    cursor: pointer;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    h5 {
      margin: 0;
      line-height: 3;
    }
    img {
      height: 55px;
    }
    p {
      font-size: 12px;
      text-align: center;
    }
  }
}
.mydivider {
  height: 2px;
  background-color: #ffffff;
}
.main {
  overflow: auto;
  width: 100%;
  height: 100%;
}
.gray_bg {
  background: linear-gradient(360deg, #f4f6f8 0%, #ffffff 100%);
}
.white_bg {
  background: white;
  .cloudOffice {
    background-color: white;
  }
  .tab_div {
    width: 100%;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    z-index: 99;
  }
  .areaDiv {
    margin-top: 30px;
    min-width: 1200px;
    & > div {
      transition: 0.2s;
      cursor: pointer;
    }
    & > div:hover {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
    .areaTab {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 40px 30px;
      height: 370px;
      box-sizing: border-box;
      img {
        height: 123px;
      }
      p {
        font-size: 12px;
        text-align: center;
        margin: 2px 0;
      }
      h5 {
        font-size: 20px;
      }
    }
  }
}
.pull-right {
  float: right;
}
.center {
  text-align: center;
}
.right {
  text-align: right;
}
.fixedNav {
  box-shadow: 0px 7px 18px 0px #a3b0bd1a;
  background: white !important;
}
.nav_div {
  margin-bottom: 0;
  padding: 20px 0;
  position: fixed;
  z-index: 999;
  background: #fcfdfd;
  .logo_img {
    vertical-align: middle;
    float: left;
    width: 36px;
  }
  .logo_title {
    font-size: 20px;
    margin-top: 8px;
    float: left;
    margin-left: 6px;
    font-family: "phzt";
  }
  .login_now,
  .tel,
  .tel_img {
    float: right;
  }
  .tel,
  .tel_img {
    font-size: 14px;
    margin: 12px 10px 12px 0px;
  }
  .tel_img {
    margin-top: 16px;
    margin-bottom: 0;
  }
}
.nav_div > div {
  width: calc(100% - 15rem);
  margin: 0 auto;
  max-width: 1680px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > div {
    min-width: 230px;
  }
}
.banner {
  height: 470px;
  position: relative;
}
.banner img {
  width: 100%;
  min-height: 470px;
}
.banner_bg {
  background-image: url(/base/images/cloudOffice/pic_background1.png);
  background-size: 100% 150px;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  height: 150px;
  // margin-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  .chinese_font {
    font-size: 30px;
    color: #333333;
    font-weight: 600;
    text-align: center;
  }
  .english_font {
    //   margin-left: -60px;
    color: #7e7e7e;
    margin-top: 15px;
  }
}
.yyfa_bg {
  background-image: url(/base/images/cloudOffice/pic_background.png);
  background-size: 100% 800px;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  // height: 150px;
  height: 800px;
}
.banner_bgtop {
  position: absolute;
  left: 120px;
  top: 50px;
  color: white;
  min-width: 500px;
  .jbyj {
    width: 300px;
    background-image: linear-gradient(to right, #6889f5, transparent);
    border-radius: 25px;
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
  }
  .zlys {
    font-size: 90px;
    margin: 0;
    font-weight: 600;
  }
  .myBtn {
    border-radius: 25px;
    background-color: white;
    color: #2e5cf1;
    font-weight: 600;
    transition-property: transform;
    transition-duration: 0.5s;
  }
  .myBtn:hover {
    transform: scale(1.1);
  }
  .myBtn2 {
    background-color: transparent;
    color: #ffffff;
    border: 1px solid #ffffff;
    border-radius: 1px;
    transition-property: transform;
    transition-duration: 0.5s;
  }
  .myBtn2:hover {
    transform: scale(1.1);
  }
  .mt30 {
    margin-top: 30px;
  }
}
.cloudOffice {
  width: calc(100% - 240px);
  margin: 0 auto;
  font-family: "Alibaba-PuHuiTi-M, Alibaba-PuHuiTi";
  color: #222;
  position: relative;
  max-width: 1680px;
  .condition-container {
    display: flex;
    align-items: center;
    height: 450px;
  }
  .tab_title {
    font-size: 24px;
    line-height: 2;
    font-weight: 600;
    color: #222;
    margin-bottom: 20px;
  }
  .border_orange::after {
    display: block;
    width: 50px;
    height: 5px;
    background-color: #fdbd28;
    content: "";
    border-radius: 5px;
  }
  .border_blue::after {
    display: block;
    width: 50px;
    height: 5px;
    background-color: #3399fe;
    content: "";
    border-radius: 5px;
  }
  .tab_info {
    font-size: 16px;
    margin-bottom: 40px;
    color: #7e7e7e;
    span {
      color: #3399fe;
    }
  }
  .myBtn_blue {
    border-radius: 25px;
    background-color: #2e5cf1;
    color: #ffffff;
    font-weight: 600;
  }
  .margin-tp-100 {
    margin-top: 100px;
  }
  .margin-tp-60 {
    margin-top: 60px;
  }
  .tab_content {
    font-size: 16px;
    margin-bottom: 15px;
    width: 100%;
    float: left;
    color: #7e7e7e;
    span {
      display: inline-block;
      margin-right: 45px;
      float: left;
    }
  }
  .el-button--primary:hover {
    background-color: #409effcc;
    border-color: #409effcc;
  }
  .el-button--primary:focus {
    background-color: #1a83eb;
  }
  p.font-large {
    margin: 0;
  }
  p.font-large:first-child {
    margin-top: 98px;
  }
  p.font-large:last-child {
    margin-bottom: 32px;
  }
  .font-large {
    font-size: 50px;
  }
  .font-small {
    font-size: 18px;
  }
  .ty_now {
    margin-top: 126px;
    margin-bottom: 192px;
    height: 69px;
    width: 230px;
    font-size: 24px;
  }

  .tab_div {
    border: 1px solid #dddddd;

    img {
      vertical-align: middle;
      width: 60px;
      margin-right: 6px;
    }
    span {
      font-size: 22px;
    }
    .el-col-6 {
      margin-bottom: 0;
      text-align: center;
      cursor: pointer;
      position: relative;
      div {
        padding: 44px 0;
      }
    }
  }

  .tab_div > .el-col-6:after {
    content: "";
    width: 0;
    height: 4px;
    position: absolute;
    background: #3399fe;
    top: 100%;
    right: 50%;
    transition: all 0.3s;
  }
  .tab_div > .el-col-6:hover:after {
    width: 100%;
    right: 0;
  }
  .tab_div > .el-col-6.active:after {
    width: 100%;
    right: 0;
  }

  .now_yy {
    height: 80px;
    width: 247px;
    font-size: 20px;
    border-radius: 12px;
    margin-top: 36px;
    margin-bottom: 120px;
  }
}
.footer {
  background-color: #34323e;
  color: white;
  padding: 45px;
  font-size: 14px;
  .footer_top {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .footer_title {
    font-size: 20px;
    margin-top: 48px;
    margin-bottom: 42px;
  }
  .footer_link {
    // width: 20%;
    // float: left;
    // margin-bottom: 100px;
    a:hover {
      text-decoration: underline;
    }
    a {
      color: white;
      //   font-size: 14px;
    }
    img {
      width: 32px;
      height: 32px;
      vertical-align: middle;
    }
  }

  .footer_info {
    // margin-bottom: 24px;
    // font-size: 12px;
    .el-col-12-first {
      text-align: right;
      padding-right: 80px;
    }
    .el-col-12-last {
      text-align: left;
      padding-right: 80px;
    }
  }
}
:deep(.el-dialog__footer) {
  text-align: center;
  padding-bottom: 40px;
}
.pht {
  font-family: "phzt";
}
.myborder:hover::before,
.myborder:hover::after {
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
  -webkit-transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
}
.myborder::before {
  border-top: 2px solid #5178f3;
  border-bottom: 2px solid #5178f3;
  -webkit-transform: scale3d(0, 1, 1);
  transform: scale3d(0, 1, 1);
}
.myborder::after {
  border-left: 2px solid #5178f3;
  border-right: 2px solid #5178f3;
  -webkit-transform: scale3d(1, 0, 1);
  transform: scale3d(1, 0, 1);
}
.myborder::before,
.myborder::after {
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  -webkit-transform-origin: center;
  -ms-transform-origin: center;
  transform-origin: center;
}
.myborder::before,
.myborder::after {
  box-sizing: border-box;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
}
.tg {
  height: 100%;
}
.tk {
  width: 100%;
}
</style>

